export type CampaignType = 'cart_discount' | 'buyXGetYOffer' | 'food-offer'

export type CampaignStatus = 1 | 2

export type CampaignFilterStatus = 1 | 2 | 'expired'

export type BuyXGetYOfferType = 'FREE_SAME' | 'FREE_DIFF' | 'DISCOUNT' | null

export type FoodOfferDiscountType = 'flat' | 'percentage'

/** 'internal' = created by Yassir through the Admin Dashboard, 'external' = the merchant. */
export type FoodOfferCreationSource = 'internal' | 'external'

export interface CampaignItemDetail {
  id?: string
  name?: string
  categoryPath?: string
  image?: string | null
  price?: number
  originalPrice?: number
  discountedPrice?: number
  quantity?: number
  isFree?: boolean
  discountPercent?: number
}

export interface CampaignBase {
  campaignId: string
  campaignType: CampaignType
  status: CampaignStatus
  createdAt: number
  validFrom: string | null
  expiryDate: number | null
  foundedBy: string | null
  orders: unknown[]
  sales: unknown[]
}

export interface CartDiscountCampaign extends CampaignBase {
  campaignType: 'cart_discount'
  code?: string
  type?: string
  discountType?: string
  amountPercentage?: number
  zoneType?: string
  city?: string
  targetAmount?: number
  maxOff?: number
  expirationTime?: string
}

export interface BuyXGetYCampaign extends CampaignBase {
  campaignType: 'buyXGetYOffer'
  name?: string
  city?: string
  nbrItemsPurchased?: number
  nbrItemsOffer?: number
  offerType?: BuyXGetYOfferType
  firstItem?: string
  items?: unknown[]
  itemToBuy?: CampaignItemDetail
  itemToGet?: CampaignItemDetail
}

export interface FoodOfferCampaign extends CampaignBase {
  campaignType: 'food-offer'
  name?: string
  offerAmount?: number
  /** Absent on older backends: treated as 'percentage'. */
  offerDiscountType?: FoodOfferDiscountType
  /** Absent on older backends: treated as 'external'. */
  creationSource?: FoodOfferCreationSource
  isEditable?: boolean
  validUntil?: string
  offerValidity?: string
  item?: CampaignItemDetail
}

export type Campaign =
  | CartDiscountCampaign
  | BuyXGetYCampaign
  | FoodOfferCampaign

export type CampaignLimit = 10 | 20 | 50 | 100

export const DEFAULT_CAMPAIGN_LIMIT: CampaignLimit = 10

export type CampaignDateRangePreset = 'week' | 'month'

export type CampaignFilters = {
  campaignTypes: CampaignType[]
  statuses: CampaignFilterStatus[]
  dateRange?: CampaignDateRangePreset
  dateFrom?: string
  dateTo?: string
}

export const EMPTY_CAMPAIGN_FILTERS: CampaignFilters = {
  campaignTypes: [],
  statuses: []
}

export interface CampaignsResponse {
  status: 1
  total: number
  page: number
  limit: number
  campaigns: Campaign[]
}

export interface FetchCampaignsParams {
  page?: number
  limit?: CampaignLimit
  skip?: number
}
